import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { DebounceConfig } from '../../config/debounce.config';
import { DirectivesModule } from '../directives/directives.module';
import { CreateApplicationComponent } from '../applications/create-application/create-application.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { DraftApplicationsListComponent } from '../applications/draft-applications-list/draft-applications-list.component';
import { SubmittedApplicationsListComponent } from '../applications/submitted-applications-list/submitted-applications-list.component';
import { LayoutModule as CdkLayoutModule } from '@angular/cdk/layout';
import { UsanFormsModule } from '../applications/forms/usan-forms.module';
import { ApplicantDashboardComponent } from './applicant-dashboard/applicant-dashboard.component';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    ApplicantDashboardComponent,
    CreateApplicationComponent,
    DraftApplicationsListComponent,
    SubmittedApplicationsListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    DirectivesModule,
    CdkLayoutModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
    UsanFormsModule,
    MatTabsModule,
    MatTooltipModule
  ],
  providers: [
    DebounceConfig,
  ]
})
export class ApplicantsModule {}
